
// 左栏主界面组件
import drawer_icon_list from "./drawer_icon_list/drawer_icon_list.vue";
// 自然资源局分局组件
import left_zrzyjfj_list from "./left_zrzyjfj_list/left_zrzyjfj_list.vue";
// 不动产受理点切换组件
import left_bdcsld_list from "./left_bdcsld_list/left_bdcsld_list.vue";
// 2023年度“招拍挂”公开出让计划 切换组件
import left_crjh_list from "./left_crjh_list/left_crjh_list.vue";

export default {
    name: 'zwfwmap_phone',


    /** 本页面用到的组件 */
    components: {
        drawer_icon_list,// 左栏主界面组件
        left_zrzyjfj_list,// 自然资源局分局切换组件
        left_bdcsld_list,// 不动产受理点切换组件
        left_crjh_list,// 2023年度“招拍挂”公开出让计划切换组件
    },

    /** 本页面的属性 */
    data() {
        return {
            drawer: false,
        };
    },

    /** 计算属性 */
    computed: {},

    /** 构建页面时 */
    mounted() {

    },

    /** 每次进入页面时 */
    activated() {

    },

    /** 每次退出页面时 */
    deactivated() {

    },
    provide() {
        return { setMessage: this.setMessage }
    },
    /** 本页面可用的方法 */
    methods: {

        setMessage(action, data) {
            var mapiframe = document.querySelector("iframe");
            console.log(action)
            console.log(data)
            console.log(mapiframe)
            mapiframe.contentWindow.postMessage({
                type: "map-emit",
                payload: {
                    action: action,
                    data: data,
                },
            },"*");
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/zwfwmap-phone/zwfwmap_phone.js